// extracted by mini-css-extract-plugin
module.exports = {"categoryPosition":"DropDownCategory_categoryPosition__ZgpKR","categoryName":"DropDownCategory_categoryName__q8vXa"};